import React from 'react';
import {
  Box, IconButton, Tooltip, alpha, useTheme,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

// ปุ่มแก้ไข/ลบในตาราง Client/Suppliers — ทั้งสองหน้าใช้ JSX ชุดนี้เหมือนกันเป๊ะ
export default function ContactRowActions({ row, onEdit, onDelete }) {
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex', gap: 0.5 }}>
      <Tooltip title="แก้ไข">
        <IconButton size="small" onClick={() => onEdit(row)} sx={{ color: theme.palette.primary.main, bgcolor: alpha(theme.palette.primary.main, 0.08), '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.18) } }}>
          <EditIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="ลบ">
        <IconButton size="small" onClick={() => onDelete(row._id)} sx={{ color: theme.palette.error.main, bgcolor: alpha(theme.palette.error.main, 0.08), '&:hover': { bgcolor: alpha(theme.palette.error.main, 0.18) } }}>
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
